import { SerializedStyles, css } from "@emotion/react";

import theme from "../../styles/theme";

export type Align = "left" | "center" | "right";

const alignMap = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

// eslint-disable-next-line import/prefer-default-export
export const container = (align: Align, top: number): SerializedStyles => css`
  display: flex;
  justify-content: ${alignMap[align]};
  margin-top: ${theme.spacing(top)}px;
`;
